import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivacyPage from './pages/PrivacyPage';
import MarketingLayout from './pages/marketing/MarketingLayout';
import HomePage from './pages/marketing/HomePage';
import VolunteersPage from './pages/marketing/VolunteersPage';
import OrganisationsPage from './pages/marketing/OrganisationsPage';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/volunteers" element={<VolunteersPage />} />
            <Route path="/organisations" element={<OrganisationsPage />} />
            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
        <Analytics />
      </BrowserRouter>
    </>
  );
}

export default App;
